import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

const template = `
<div class="mt-12 text-center max-w-160 ml-auto mr-auto">
    <h1 class="text-2xl text-rose-500">Error Loading Station Information</h1>
    <p class="text-lg mt-4">
    It looks like we ran into an error trying to start the application.  Please make sure you are online and scripts have not been blocked for this page.
    </p>
    <div class="text-xl font-bold text-blue-700 mt-6">
        <a routerLink="/">Reload!</a>
    </div>
</div>
`;
@Component({
  template: template,
  standalone: true,
  imports: [RouterLink],
})
export class StationNotLoadedPage {}
